export const CUSTOM_PRODUCT_COMPONENT_IDS = {
  CARD_BUTTON: "card-button",
  PAGE_SIDEBAR_BUTTON: "page-sidebar-button",
};
